import { render, staticRenderFns } from "./warehouseRuleModule.vue?vue&type=template&id=f8980746&scoped=true"
import script from "./warehouseRuleModule.vue?vue&type=script&lang=js"
export * from "./warehouseRuleModule.vue?vue&type=script&lang=js"
import style0 from "./warehouseRuleModule.vue?vue&type=style&index=0&id=f8980746&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8980746",
  null
  
)

export default component.exports